import { render, staticRenderFns } from "./NewspaperForm.vue?vue&type=template&id=f26b4be4&scoped=true&"
import script from "./NewspaperForm.vue?vue&type=script&lang=js&"
export * from "./NewspaperForm.vue?vue&type=script&lang=js&"
import style0 from "./NewspaperForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewspaperForm.vue?vue&type=style&index=1&id=f26b4be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26b4be4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VDatePicker,VFileInput,VForm,VIcon,VImg,VMenu,VTextField})
